import { render, staticRenderFns } from "./RTapClients.vue?vue&type=template&id=dbdec188&"
import script from "./RTapClients.vue?vue&type=script&lang=js&"
export * from "./RTapClients.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports